import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackStartReturnRequestParameters extends TrackEventBaseParameters {}

const trackStartReturnRequest = (
    parameters: TrackStartReturnRequestParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "start_return_request", ...parameters }, options);
};

export default trackStartReturnRequest;
